import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;

  idCampanha?: number;
}
export function useGetDetalheCampanha(props: Props) {
  const hasIdCampanha = props.idCampanha ? `${props.idCampanha}/` : "";
  const fetchData = async () => {
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/campanha/v1/${hasIdCampanha}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "detalhe_campanha"],
    refetchOnWindowFocus: false,
  });

  return query;
}
